import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SelectBankLayer extends cc.Component {    
    @property(cc.Layout)
    lytContent: cc.Layout = null

    @property(cc.Animation)
    animation: cc.Animation = null
    
    @property(cc.Node)
    nodeTemplate: cc.Node = null

    @property(cc.ToggleContainer)
    toggleContainer: cc.ToggleContainer = null

    @property([])
    bankList: Array<any> = []

    @property({type: cc.Integer, visible: false})
    selectedIndex: number = 0
    
    callback = null

    onLoad () {
        this.nodeTemplate.parent = null
        this.node.active = false
    }

    onEnable () {
        this.animation.play()
        this.lytContent.node.destroyAllChildren()

        for (let i = 0; i < this.bankList.length; i++) {
            const cfg = this.bankList[i];
            let node = cc.instantiate(this.nodeTemplate)
            node.parent = this.lytContent.node
            node.getChildByName("name").getComponent(cc.Label).string = cfg.bankname
            node.getChildByName("account").getComponent(cc.Label).string = cfg.bankNum
            cfg.logoUrl && cc.loader.load({url: cfg.logoUrl, type: "png"}, function (err, texture) {
                if (!err && node && node.isValid) {
                    node.getChildByName("icon").getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
                }
            }.bind(this))

            if (this.selectedIndex === i) {
                this.scheduleOnce(function () {
                    node.getComponent(cc.Toggle).isChecked = true
                }, 0.01)
            }
        }
    }

    onDestroy () {
        this.nodeTemplate.destroy()
    }

    onBtnClick (event, data) {
        if (data === "close") {
            AudioManager.playSound("close")
            this.animation.play("exit_select_bank")
        }else if (data === "select") {
            this.animation.play("exit_select_bank")

            for (let i = 0; i < this.toggleContainer.toggleItems.length; i++) {
                const toggle = this.toggleContainer.toggleItems[i];
                if (toggle.isChecked && this.callback) {
                    this.callback(i)
                    break
                }
            }
        }
    }

    onExitAnimationEnd () {
        this.node.active = false
    }
}
